import { Facility } from './types';
import {env} from '../../config/env';

export const API_URL_CMP = env.API_ENDPOINT_URL;
// The base URL for the maintenance API.
export const API_BASE_URL = `${API_URL_CMP}/careadmin/maintenance`;
// The API key for authenticating with the maintenance API.
export const API_KEY = env.API_ENDPOINT_KEY;

// A static list of available facilities, used for the facility switcher.
export const facilities: Facility[] = [
  { id: 1, name: 'The Mansion Gasing 136', logoUrl: 'https://mycareconcierge.com/wp-content/uploads/2024/10/mansion-gasing-136-2.png' },
  { id: 2, name: 'The Mansion Seksyen 14', logoUrl: 'https://mycareconcierge.com/wp-content/uploads/2024/10/mansion-sri-aman-1.png' },
  { id: 3, name: 'The Mansion Gasing 58', logoUrl: 'https://mycareconcierge.com/wp-content/uploads/2024/10/mansion-gasing-58-2.png' },
  { id: 4, name: 'Komune Care', logoUrl: 'https://bin.mycareconcierge.com/cga/komune_care_assisted_living.jpg' },
  { id: 5, name: 'Tanjung Point', logoUrl: 'https://mycareconcierge.com/wp-content/uploads/2024/10/tanjung-point-residences.png' },
  { id: 6, name: 'Home Care', logoUrl: 'https://bin.mycareconcierge.com/cga/homcare.jpg' },
  { id: 7, name: 'The Mansion Ritchie', logoUrl: 'https://mycareconcierge.com/wp-content/uploads/2024/10/mansion-ritchie.png' },
  { id: 8, name: 'Xero Demo Centre', logoUrl: 'https://www.themansion.com.my/wp-content/uploads/2021/01/mansion_gasing136.jpg' },
  { id: 9, name: 'Angsana Home', logoUrl: 'https://www.themansion.com.my/wp-content/uploads/2021/01/mansion_gasing136.jpg' },
  { id: 10, name: 'Ara Woods', logoUrl: 'https://www.themansion.com.my/wp-content/uploads/2021/01/mansion_gasing136.jpg' },
  { id: 11, name: 'Jaya One Daycare', logoUrl: 'https://bin.mycareconcierge.com/cga/homcare.jpg' },
];

/**
 * A mapping of issue category keys (stored in the database) to their user-facing display names.
 */
export const ISSUE_CATEGORIES: { [key: string]: string } = {
  'customer_refund': '[RN] Customer Refund',
  'change_request': '[CN] Change Request',
  'cancel_order': '[CN] Cancel Order',
  'discount_request': '[CN] Discount Request',
  'clarification_query': '[QR] Clarification / Query',
  'error': '[ER] Error Detected',
  'top_up_request': '[DN] Top Up Request',
  'room_aircon': 'Room🏠 - Air conditioning (leak, not cold, noisy)',
  'room_lighting': 'Room🏠 - Lighting (bulb/fuse issues, dim, flickering)',
  'room_electrical_outlets': 'Room🏠 - Electrical outlets / switches',
  'room_water_heater': 'Room🏠 - Water heater / shower issues',
  'room_plumbing': 'Room🏠 - Plumbing (toilet, sink, leakage)',
  'room_door_lock': 'Room🏠 - Door lock / knob issues',
  'room_wardrobe_cabinet': 'Room🏠 - Wardrobe / cabinet repair',
  'room_flooring': 'Room🏠 - Flooring (tiles, vinyl lifting, wet floor)',
  'room_paint_wall': 'Room🏠 - Paint & wall patching',
  'room_pest_control': 'Room🏠 - Pest control (room-specific)',
  'common_lounge': 'Common Areas🛠️ - Lounge / Living Room',
  'common_dining': 'Common Areas🛠️ - Dining Hall',
  'common_hallways_lobby': 'Common Areas🛠️ - Hallways & Lift Lobbies',
  'common_restrooms': 'Common Areas🛠️ - Restrooms (common toilet leaks, flush, etc.)',
  'common_clubhouse': 'Common Areas🛠️ - Clubhouse / Activity Room',
  'common_gym_physio': 'Common Areas🛠️ - Gym / Rehab / Physio areas',
  'outdoor_garden_landscaping': 'Facility Outdoor🌳 - Garden / Landscaping (fallen branches, dead plants)',
  'outdoor_pathways': 'Facility Outdoor🌳 - Pathways & walkways (cracks, uneven flooring)',
  'outdoor_drainage': 'Facility Outdoor🌳 - Drainage / water pooling',
  'outdoor_fencing_gate': 'Facility Outdoor🌳 - Perimeter fencing / gates',
  'outdoor_facade_signage': 'Facility Outdoor🌳 - Façade damage / signboard lighting',
  'housekeeping_washer_dryer': 'Housekeeping🧼 - Washer/dryer breakdown',
  'housekeeping_chemical_supply': 'Housekeeping🧼 - Chemical supply low',
  'housekeeping_linen_shortage': 'Housekeeping🧼 - Linen shortage',
  'housekeeping_equipment_failure': 'Housekeeping🧼 - Housekeeping equipment failure (vacuum, trolley)',
  'housekeeping_stains_odours': 'Housekeeping🧼 - Stains or odours reported',
  'utilities_power_outage': 'Utilities & Equipment🔋 - Power outage / tripping',
  'utilities_generator_failure': 'Utilities & Equipment🔋 - Generator / Backup power failure',
  'utilities_water_pump': 'Utilities & Equipment🔋 - Water tank / booster pump issue',
  'utilities_internet_wifi': 'Utilities & Equipment🔋 - Internet / Wi-Fi downtime',
  'utilities_cctv': 'Utilities & Equipment🔋 - CCTV malfunction',
  'utilities_intercom_pabx': 'Utilities & Equipment🔋 - Intercom / PABX system issue',
  'utilities_nurse_call': 'Utilities & Equipment🔋 - Nurse call bell system',
  'clinical_bed_motor': 'Clinical Equipment🛏️ - Hospital bed motor issue',
  'clinical_wheelchair_walker': 'Clinical Equipment🛏️ - Wheelchair or walker servicing',
  'clinical_oxygen_concentrator': 'Clinical Equipment🛏️ - Oxygen concentrator malfunction',
  'clinical_lifting_commode': 'Clinical Equipment🛏️ - Lifting hoist / commode chair issues',
  'clinical_thermometer_bp': 'Clinical Equipment🛏️ - Thermometer / BP machine',
  'safety_fire_extinguisher': 'Safety🔒 - Fire extinguisher expired / missing',
  'safety_emergency_lighting': 'Safety🔒 - Emergency light / exit signs not working',
  'safety_smoke_alarm': 'Safety🔒 - Smoke detectors / alarm false alert',
  'safety_aed_first_aid': 'Safety🔒 - AED / First aid kit incomplete',
  'safety_hazard_spill': 'Safety🔒 - Hazardous spill / slippery areas',
  'it_tablet_resident': 'IT & Software🧑‍💻 - Resident tablet not working',
  'it_qr_attendance': 'IT & Software🧑‍💻 - Attendance/QR system issue',
  'it_staff_device': 'IT & Software🧑‍💻 - Staff devices (mobile, tablet)',
  'it_maintenance_login': 'IT & Software🧑‍💻 - Maintenance app login issue',
  'it_smart_device': 'IT & Software🧑‍💻 - Smart home devices (if used)',
  'others_general': 'Others📄',
};
